import type { HTMLComponent } from "@commercekit/react";
import { asText } from "@prismicio/helpers";
import type { ImageAndTextContentSliceDefault } from "prismicio-types";
import { useMemo } from "react";
import { wrapIframe } from "@commercekit/shared";
import { optimizeImageUrl } from "~/lib/imageUtils";

const LeftImageAndRightText: HTMLComponent<{
  slice: ImageAndTextContentSliceDefault;
}> = ({ slice }) => {
  const content = useMemo(() => {
    return wrapIframe(asText(slice.primary.content));
  }, [slice.primary.content]);

  return (
    <div className="col-12 px-0 content">
      <div className="container">
        <div className="row">
          <div className="col-12">
           { slice.primary.title && slice.primary.title.length > 0 && (
            <h1 className="heading strong xl underlined left pb-3 mb-3">
              {asText(slice.primary.title)}
            </h1>
            )}
          </div>
        </div>

        <div className="row">
          <div className="d-flex align-items-start col-12 col-md-6 pr-lg-4 pr-xl-5 order-2">
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: content || "",
              }}
            ></div>
          </div>
          <div className="col-12 col-md-6 order-1 image-w-text-no-padding">
            <div className="content__image">
              <div className="img">
                <img
                  src={optimizeImageUrl(slice.primary.image.url ?? "")}
                  alt={slice.primary.image.alt ?? ""}
                  className="img h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftImageAndRightText;
